import { AxiosResponse } from 'axios';

import { useSuspenseQuery } from '@tanstack/react-query';
import type { TypeGetGuestAccountsMeResponse } from '~/api/guestAccounts';
import { registerMockAPI } from '~/mocks/mockApis';

import { axiosInstance } from '~/services/fetchServiceV2';
import { useGuestTokenStore } from '~/store';

/** @desciption 비회원 인증 토큰으로 비회원 개인 정보를 조회하는 커스텀 훅 */
export const useGetGuestPrivacyInfo = () => {
  return useSuspenseQuery({
    queryKey: ['guest-labor-accounts', 'me'],
    queryFn: () => axiosInstance.get<TypeGetGuestAccountsMeResponse>('/guest-accounts/me'),
    gcTime: 0,
    retry: 1,
    select: (response: AxiosResponse<TypeGetGuestAccountsMeResponse>) => response.data,
  });
};

registerMockAPI<TypeGetGuestAccountsMeResponse>({
  method: 'get',
  endpoint: '/guest-accounts/me',
  label: '근무 지원 정보/비회원 정보 조회',
  scenarios: [
    {
      name: '지원 정보 있음',
      preCondition: {
        action: () => {
          useGuestTokenStore.getState().actions.setGuestToken('temp-guest-token');
        },
        cleanUp: () => {
          setTimeout(() => {
            useGuestTokenStore.getState().actions.resetGuestToken();
          }, 1000);
        },
      },
      response: {
        code: '0000',
        message: '성공',
        data: {
          name: '홍길동',
          phoneNumber: '01012345678',
          birthDate: '900115',
          genderDigit: '1',
        },
      },
    },
    {
      name: '토큰 만료',
      status: 401,
      response: {
        code: 'AUTH_GUEST',
        message: '토큰이 만료되었습니다.',
        data: null,
      } as unknown as TypeGetGuestAccountsMeResponse,
    },
  ],
});
